var _rect, _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _path5, _circle4, _circle5, _ellipse, _ellipse2, _ellipse3, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path6, _ellipse4, _circle12, _ellipse5, _circle13, _path7, _path8, _path9, _path10, _g, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#4aa3a2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#5faead",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#4f8f5f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88L58 104L52 94Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87L60 100L74 87L68 85L60 92L52 85Z",
    fill: "#fbfaf5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100L60 124",
    stroke: "#3f724c",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 108,
    r: 1.3,
    fill: "#3f724c"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 116,
    r: 1.3,
    fill: "#3f724c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d8b99d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f6d3b3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 61,
    r: 0.9,
    fill: "#9f8974"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 62.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 63.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 61,
    r: 0.9,
    fill: "#9f8974"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 62.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 63.5,
    r: 0.9,
    fill: "#9f8974"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bfa48b",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#a5502c",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#a5502c",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52 67Q60 75 68 67",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52C33 30 50 21 62 22C76 23 85 33 82 52C80 44 77 38 71 35C62 41 49 39 43 45C40 47 39 50 38 52Z",
    fill: "#a5502c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 0.18,
    stroke: "#3b3b4a",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 54,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 54,
    r: 7.5
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 53Q60 51.5 61.5 53M43.5 53L38 51M76.5 53L82 51",
    stroke: "#3b3b4a",
    strokeWidth: 2,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait1);
export default __webpack_public_path__ + "static/media/player-portrait-1.50bb11d3a5d377a209233b5fe74169d5.svg";
export { ForwardRef as ReactComponent };